function Warning({ svgIconSize, style }) {
    return (
        <svg
            version="1.1"
            x="0px"
            y="0px"
            width="145.664px"
            height="137.097px"
            viewBox="0 0 145.664 137.097"
            enableBackground="new 0 0 145.664 137.097"
            style={{
                width: svgIconSize,
                height: svgIconSize,
                ...style,
            }}
        >
            <rect
                x="-152.168"
                y="-156.452"
                display="none"
                fill="#F7F7F7"
                width="450"
                height="450"
            />
            <g>
                <path
                    fill="#F03636"
                    d="M131.712,137.097H13.952c-10.359,0-17.096-10.262-12.463-18.985l58.88-110.86
		c5.135-9.669,19.791-9.669,24.927,0l58.88,110.86C148.808,126.834,142.07,137.097,131.712,137.097z"
                />
                <g>
                    <path
                        fill="#FFFFFF"
                        d="M72.832,97.821L72.832,97.821c-2.835,0-5.229-1.156-5.352-2.643l-4.246-51.131
			c-0.424-5.111,3.857-9.598,9.598-9.598l0,0c5.741,0,10.023,4.487,9.598,9.598l-4.246,51.131
			C78.061,96.665,75.667,97.821,72.832,97.821z"
                    />

                    <ellipse
                        transform="matrix(0.9247 -0.3808 0.3808 0.9247 -37.2269 36.1814)"
                        fill="#FFFFFF"
                        cx="72.832"
                        cy="112.179"
                        rx="8.281"
                        ry="8.281"
                    />
                </g>
            </g>
        </svg>
    );
}

export default Warning;
